import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

import { FieldMatch } from "src/flowGraph/canvasSearch/extractNodeFields";

export const HIGHLIGHT_CLASSES =
  "bg-yellow-50 border border-yellow-400" as const;

type CanvasSearchHighlightContextValue = {
  highlightedMatch: FieldMatch | null;
  setHighlightedMatch: (match: FieldMatch | null) => void;
};

const CanvasSearchHighlightContext =
  createContext<CanvasSearchHighlightContextValue>({
    highlightedMatch: null,
    setHighlightedMatch: () => {},
  });

export const CanvasSearchHighlightProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [highlightedMatch, setHighlightedMatch] = useState<FieldMatch | null>(
    null,
  );

  const value = useMemo(
    () => ({
      highlightedMatch,
      setHighlightedMatch,
    }),
    [highlightedMatch],
  );

  return (
    <CanvasSearchHighlightContext value={value}>
      {children}
    </CanvasSearchHighlightContext>
  );
};

export const useCanvasSearchHighlight = () => {
  return useContext(CanvasSearchHighlightContext);
};

export const useIsFieldHighlighted = (fieldId: string | undefined): boolean => {
  const { highlightedMatch } = useContext(CanvasSearchHighlightContext);

  if (!fieldId || !highlightedMatch) {
    return false;
  }

  return highlightedMatch.fieldId === fieldId;
};
